// extracted by mini-css-extract-plugin
export var actions = "_mq-5";
export var assistantBubble = "_mq-3";
export var assistantRow = "_mq-6";
export var bubble = "_mq-0";
export var humanAvatar = "_mq-4";
export var inlineToolCard = "_mq-1";
export var userBubble = "_mq-2";